import MainLayout from '../../../../commons/layout/MainLayout';
import VideoComponentCustom from '../../../../commons/components/Video';
import { useNavigate } from 'react-router-dom';
import ROUTERS from '../../../../commons/constans/router';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { log } from '../../../../utils/helpers';
import TextareaComponent from '../../../../commons/components/Forms/TextareaComponent';

type Props = {
  handleClosePublic: Function,
  videoDetail: Object,
  videoEmoji: Array,
  deleteVideo: Function,
  isProcessing: Boolean
};
const VideoPlayerComponent = ({
  handleClosePublic,
  videoDetail,
  videoEmoji,
  deleteVideo,
  isProcessing
}: Props) => {
  const videoRef = useRef();
  const navigate = useNavigate();
  const [onClose, setOnclose] = useState(false);
  const [statusDialogUpdateSuccess, setStatusDialogUpdateSuccess] = useState(false);
  const {userInfo} = useSelector((state) => state.authReducers);
  const [isPlayVideo, setIsPlayVideo] = useState(true);
  const [isClickVideo, setIsClickVideo] = useState(false);
  
  console.log(isProcessing, 'isProcessing');
  const handleLeftClick = () => {
    navigate(ROUTERS.HOME);
  };

  const onClosePublic = () => {
    setOnclose(true);
  };

  handleClosePublic = () => {
    setOnclose(false);
  };
  
  const closePopupStatus = () => {
    navigate(ROUTERS.VIDEO_DETAIL_PATH(videoDetail?.id), {state: {prevPath: 'prevPath'}})
  }

  const handleDialogConfirmUpdateStatus = (data) => {
    setStatusDialogUpdateSuccess(true);
  }

  const handleCloseUpdate = () => {
    setStatusDialogUpdateSuccess(false);
  }

  const handleClick = () => {
    if (!isPlayVideo) {
      setIsClickVideo(!isClickVideo);
    }
  }

  useEffect(() => {
    if (isProcessing === false) {
      if (isClickVideo) {
        document.getElementsByClassName('video-react-control-bar')[0].classList.add('d-none');
        document.getElementById('player-custom-video').classList.remove('background-video');
      }else{
        document.getElementsByClassName('video-react-control-bar')[0].classList.remove('d-none');
        document.getElementById('player-custom-video').classList.add('background-video');
      }
    }
    
  }, [isClickVideo])

  const handlePlayStatus = (status) => {
    console.log(74, 'handlePlayStatus');
    setIsPlayVideo(status);
    
    if (status && isProcessing === false) {
      document.getElementsByClassName('video-react-control-bar')[0].classList.remove('d-none');
      document.getElementById('player-custom-video').classList.add('background-video');
    }
  }

  const showVideoFullScreen = () => {
    videoRef.current.showVideoFullScreen()
  }

  console.log(videoDetail, 'videoDetail 1111');
  return (
    <MainLayout
      pageID={'video-player-show'}
      handleLeftClick={() => handleLeftClick()}
      displayBottomNav={false}
    >
      {/* {
        isProcessing === false &&  */}
      <div className="wrapper" id='video-container' onClick={() => handleClick()}>
        <VideoComponentCustom
          ref={videoRef}
          onClosePublic={onClose}
          videoDetail={videoDetail}
          resetHandleClosePublic={handleClosePublic}
          deleteVideo={deleteVideo}
          userInfo={userInfo}
          handlePlayStatus={handlePlayStatus}
          videoRecommend
        />
        <div style={{zIndex: 9}}>
          <div className="album-video-detail-page__title">
            <div className="d-flex justify-content-between">
              <div className ></div>
              <h4 className="album-video-detail-page__title-video-page ml-4">
                영상 후기
              </h4>
              <img
                src="/images/album/icon_X_black_small.svg"
                className="album-video-detail-page__icon-delete"
                alt=""
                onClick={showVideoFullScreen}
              />
            </div>
          </div>
          <div className="album-video-detail-page__public">
            <div className="row content">
              <div className="col-12 mt-4 mb-3">
                <TextareaComponent
                  isRequired={true}
                  placeHolder={`10자이상의 후기를 남겨주세요. \n스포키즈에 큰 힘이 됩니다!`}
                  name={`reaction_content`}
                  value={videoDetail.video_message?.reaction_content || ''}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* } */}
    </MainLayout>
  );
};

export default VideoPlayerComponent;
